import {PlacePathFileValueObject} from "../../../model/vo/content/place/PlacePathFileValueObject";
import {defaultIO} from "../../DefaultIO";
import {HttpClient} from "../../HttpClient";

export const PlacePathFileIO = {
    ...defaultIO(
        '/api/v3/contents/places/paths/files',
        PlacePathFileValueObject.construct
    ),
    async postFile(guideLineFile: File, id:string): Promise<PlacePathFileValueObject> {
        const formData = new FormData()
        formData.append('file', guideLineFile)

        const response = await fetch(`${process.env.REACT_APP_API_HOST}/api/v3/contents/places/paths/files/${id}`,
            {
                method: 'PATCH',
                body: formData,
            },
        )

        return HttpClient.handleResponse(response, PlacePathFileValueObject.construct)
    }
}